module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAeCAYAAABAFGxuAAAAAXNSR0IArs4c6QAAALdJREFUWEfN2MENgCAMBdDvJq7iRm7iKm7gKm6iqfGo0pb8X7lwAh6lSRsG/HQMRNcMYAWwZ85gwQy13Kgpg2PBRgAbAJstYmEcC2av14VjwrpwbFgap4ClcCpYGKeEhXBqmBtXAXPhqmBNXCXsE1cNe8UZ7MhUf+Kaq7b+Gka8vGvrx2JfnWOvHUgl7LMtqoI1e7UKWBNlmamGuVBqmBulhIVQKlgYpYClUGxYGsWEdaGYsO4vghMTeVRf2ZivUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group 70@2x.png
// module id = Ik1I
// module chunks = 1